<!--
 * @Author: your name
 * @Date: 2021-05-19 17:07:01
 * @LastEditTime: 2021-09-15 12:01:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ope\src\views\content\yirongtongShop\components\yrtBanner.vue
-->
<template>
  <section class="control_box">
    <el-dialog
      :append-to-body="true"
      title="主推商品区"
      width="800px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <div>
        <div class="margin-b10">
          <el-form
            ref="floorRuleForm"
            :model="floorItem"
            :rules="rules1"
            label-width="100px"
          >
            <el-form-item label="主推标题:" prop="title">
              <el-input
                v-model.trim="floorItem.title"
                maxlength="6"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="楼层主图:" prop="imgUrl">
              <el-upload
                class="oneimg-upload"
                :action="uploadImgUrl"
                :headers="header"
                :show-file-list="false"
                :before-upload="beforeImgUpload1"
                :on-success="handleImgSuccess1"
                accept=".jpeg,.jpg,.png"
              >
                <el-image
                  v-if="floorItem.imgUrl"
                  :src="floorItem.imgUrl"
                  fit="fill"
                ></el-image>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="tips">
                  轮播图尺寸需为宽232px、高816px，仅支持jpg、png格式，图片不得超过1M
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="跳转链接:">
              <el-input v-model.trim="floorItem.linkUrl"></el-input>
            </el-form-item>
            <el-form-item
              label="商品设置:"
              required
              v-if="floorItem.productList.length < 8"
            >
              <el-button
                type="primary"
                @click.native.prevent="showDialog('新增')"
                >新增商品</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="floorItem.productList" border max-height="500px">
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column prop="name" label="商品名称">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                title="商品名称:"
                width="300"
                trigger="hover"
              >
                <div>{{ scope.row.name }}</div>
                <span slot="reference">{{
                  scope.row.name.substr(0, 10) + '...' + ''
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="商品价格"
            align="center"
          ></el-table-column>
          <el-table-column prop="imgUrl" label="图片预览" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 80px; height: 80px"
                :src="scope.row.imgUrl"
                :preview-src-list="scope.row.imgUrl.split(',')"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="320">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click.native.prevent="showEditDialog(scope)"
                >编辑</el-button
              >
              <el-button
                <el-button
                type="text"
                @click.native.prevent="
                  deleteRow(scope.$index, floorItem.productList)
                "
                >删除</el-button
              >
              <el-button
                icon="el-icon-top"
                type="text"
                @click.native.prevent="up(scope.$index)"
                >上移</el-button
              >
              <el-button
                icon="el-icon-bottom"
                type="text"
                @click.native.prevent="down(scope.$index)"
                >下移</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="tip-list">
          <p>1.必须维护满8个商品，有空缺时不允许提交审核。</p>
      </div> -->
      </div>
      <div slot="footer" class="dialog-footer flex-c">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="floorSubmit('floorRuleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <item-edit-dialog
      :item-dialog-visible.sync="itemDialogVisible"
      :item-dialog-data="itemDialogData"
      @submitPopupData="submitPopupData"
    />
    <!-- 新增/编辑轮播图 -->
    <product-dialog
      :product-dialog-visible.sync="productDialogVisible"
      @getProductDialogInfo="getProductDialogInfo"
    />
  </section>
</template>

<script>
import Vue from 'vue';
import { epecToken } from '../../utils/globalData';
import api from '../../api/cms/index';
import productDialog from './productDialog.vue'; // 选择商品
import itemEditDialog from './itemEditDialog.vue';

export default {
  components: {
    productDialog,
    itemEditDialog,
  },
  props: {
    activeName: {
      type: String,
      default: '',
    },
    activeFloor: {
      default: '',
    },
    floorList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      header: epecToken,
      dialogVisible: false,
      floorItem: {
        isHidden: false,
        title: '',
        linkUrl: '',
        imgUrl: '',
        productList: [],
      },
      rules: {
        skuId: [{ required: true, message: '请填写商品ID', trigger: 'blur' }],
        name: [{ required: true, message: '请填写商品名称', trigger: 'blur' }],
        imgUrl: [{ required: true, message: '请上传商品图', trigger: 'blur' }],
      },
      rules1: {
        title: [{ required: true, message: '请填写主推标题', trigger: 'blur' }],
        imgUrl: [
          { required: true, message: '请上传楼层主图', trigger: 'blur' },
        ],
      },
      dialogFormVisible: false,
      itemDialogVisible: false,
      itemDialogData: {},
      dialogTitle: '',
      activeInde: '',
      formData: {
        skuId: '',
        supplierCompanyId: '',
        name: '',
        imgUrl: '',
        price: '',
        exportStatus: '',
      },
      productDialogVisible: false,
    };
  },
  watch: {
    activeName(newV, oldV) {
      console.log(newV, oldV);
      this.dialogVisible = newV == 'floor2';
    },
    activeFloor(newV, oldV) {
      console.log(newV, oldV);
      this.floorItem =
        newV !== ''
          ? this.floorList[newV]
          : {
              isHidden: false,
              title: '',
              linkUrl: '',
              imgUrl: '',
              productList: [],
            };
    },
  },
  created() {
    this.uploadImgUrl = api.fileUpload;
  },
  methods: {
    closeDialog() {
      this.$parent.choosenComments('');
    },

    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 编辑商品
    showEditDialog(itemDialogData) {
      this.itemDialogVisible = true;
      const { $index, row } = itemDialogData;
      console.log(itemDialogData, 123123);
      this.itemDialogData = {
        $index,
        row,
      };
    },
    submitPopupData(data, itemDialogData) {
      // 点击确定返回值
      // console.log(data, 'data');
      itemDialogData.row.jumpType = data.jumpType;
      itemDialogData.row.itemlinkUrl = data.itemlinkUrl;
      console.log(this.floorItem);
      this.itemDialogVisible = false;
    },
    showDialog() {
      this.productDialogVisible = true;
    },
    up(index) {
      if (index === 0) {
        return;
      }
      // 在上一项插入该项
      this.floorItem.productList.splice(
        index - 1,
        0,
        this.floorItem.productList[index]
      );
      // 删除后一项
      this.floorItem.productList.splice(index + 1, 1);
    },
    down(index) {
      if (index === this.floorItem.productList.length - 1) {
        return;
      }
      // 在下一项插入该项
      this.floorItem.productList.splice(
        index + 2,
        0,
        this.floorItem.productList[index]
      );
      // 删除前一项
      this.floorItem.productList.splice(index, 1);
    },

    handleImgSuccess1(res, file) {
      console.log(file);
      if (res.success) {
        // this.floorItem.imgUrl=res.data.url;
        Vue.set(this.floorItem, 'imgUrl', res.data.url);
        this.$message.success('上传成功！');
      }
    },
    beforeImgUpload1(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return false;
      }
      if (!isJPG) {
        this.$message.error('上传图片只能是jpg或者jpeg格式!');
        return false;
      }
      if (isJPG) {
        const _this = this;
        let imgWidth = '';
        let imgHight = '';
        console.log(imgWidth, imgHight);
        const isSize = new Promise(function (resolve, reject) {
          const width = 232;
          const height = 816;
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.onload = function () {
            imgWidth = img.width;
            imgHight = img.height;
            const valid = img.width <= width && img.height <= height;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(
          () => {
            return file;
          },
          () => {
            _this.$message.warning({
              message:
                '上传文件的图片大小不符合标准,图片宽度应小于232px，图片高度应小于816px',
              btn: false,
            });
            return Promise.reject();
          }
        );
        return isSize;
      }
      return isJPG && isLt1M;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTitle == '新增') {
            this.floorItem.productList.push(this.formData);
          } else if (this.dialogTitle == '编辑') {
            this.floorItem.productList.splice(this.activeInde, 1, {
              ...this.formData,
            });
          }

          this.dialogFormVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    floorSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.floorList[this.activeFloor] = this.floorItem;

          this.dialogVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 得到所选产品的信息
    getProductDialogInfo(val) {
      val.forEach((item) => {
        const obj = {
          skuId: item.skuId,
          price: item.price,
          supplierCompanyId: item.supplierCompanyId,
          name: item.skuName,
          exportStatus: item.exportStatus,
          imgUrl: item.defaultImage,
          ...item,
        };
        let isOk = true;
        this.floorItem.productList.forEach((list) => {
          if (item.skuId == list.skuId) {
            isOk = false;
            this.$message.error('重复添加商品！');
          }
        });
        if (isOk) {
          this.floorItem.productList.push(obj);
        }
      });
      if (this.floorItem.productList.length > 8) {
        this.$message.error('添加商品不能超过8个');
        this.floorItem.productList = this.floorItem.productList.slice(0, 8);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/theme.scss';
.control_box {
  background: #fff;
  .box-card-header {
    font-weight: 600;
  }
}
.tip-list {
  background: #f4f7ff;
  padding: 10px;
  margin-top: 10px;
  p {
    color: $c6;
    line-height: 32px;
  }
}
.oneimg-upload {
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;

  cursor: pointer;
}
.oneimg-upload ::v-deep .el-upload--text {
  width: 212px;
  height: 212px;
  line-height: 212px;
  border: 1px dashed #d9d9d9;
  .el-image {
    height: 100%;
  }
}
</style>
